import { apiRequest } from "../utils/api";
import { pickedOtpChannel } from "../components/OtpChannelNote";

export const authService = {
  // `channel: "SMS"` asks for the code by SMS instead of WhatsApp (D6); the app
  // language picks the language of a WhatsApp code.
  sendOtp(phone, purpose = "", channel) {
    let lang;
    try { lang = localStorage.getItem("app_lang") || undefined; } catch { lang = undefined; }
    return apiRequest("/auth/send-otp", {
      method: "POST",
      body: JSON.stringify({ phone, purpose, lang, channel: channel || pickedOtpChannel() })
    });
  },

  verifyOtp(phone, otp, purpose = "") {
    return apiRequest("/auth/verify-otp", {
      method: "POST",
      body: JSON.stringify({ phone, otp, purpose })
    });
  },

  setPassword(phone, password, email, name) {
    return apiRequest("/auth/set-password", {
      method: "POST",
      body: JSON.stringify({ phone, password, email, name })
    });
  },

  setDisplayName(phone, displayName) {
    return apiRequest("/auth/display-name/set", {
      method: "POST",
      body: JSON.stringify({ phone, displayName })
    });
  },

  checkUser(phone) {
    return apiRequest("/auth/check-user", {
      method: "POST",
      body: JSON.stringify({ phone })
    });
  },

  checkDisplayName(name) {
    return apiRequest(`/auth/display-name/check?name=${encodeURIComponent(name)}`, {
      method: "GET"
    });
  },

  login(phone, password) {
    return apiRequest("/auth/login", {
      method: "POST",
      body: JSON.stringify({ phone, password })
    });
  },

  forgotPasswordInit(identifier) {
    return apiRequest("/auth/forgot-password/init", {
      method: "POST",
      body: JSON.stringify({ identifier })
    });
  },

  forgotPasswordVerify(resetToken, otp) {
    return apiRequest("/auth/forgot-password/verify", {
      method: "POST",
      body: JSON.stringify({ resetToken, otp })
    });
  },

  forgotPasswordReset(verifiedToken, password) {
    return apiRequest("/auth/forgot-password/reset", {
      method: "POST",
      body: JSON.stringify({ verifiedToken, password })
    });
  }
};
